export const SENDER_TYPE_COMPANY = 'company'
